export default __webpack_public_path__ + "static/media/ea-title-cn.6db333d1.webp";